import { SearchSuggestionType } from '@api/models';

import { ApiClient } from '@website/lib/api';
import { getTranslation } from '@website/utils/i18n';

export interface Suggestion {
  type: SearchSuggestionType;
  id: string;
  name: string;
}

/**
 * Fetches keyword search suggestions for the given query.
 * Returns an empty array when the query is empty so callers can use it as a no-op.
 */
export const getSuggestions = async (q: string, locale: string): Promise<Suggestion[]> => {
  const trimmed = q.trim();
  if (!trimmed) return [];

  try {
    const response = await ApiClient.getSuggestions({ q: trimmed }, { authRequired: false } as RequestInit);
    return response.suggestions
      .map((suggestion) => ({
        type: suggestion.type,
        id: suggestion.id,
        name: getTranslation(suggestion.name, locale, '')
      }))
      .filter((suggestion) => suggestion.name.length > 0);
  } catch (error) {
    console.error('Failed to fetch search suggestions:', error);
    return [];
  }
};
